import { logout } from "@umami/state";

import { persistor } from "../../utils/persistor";
import { store } from "../../utils/store";
import { getRemoveDefaultAccountDescription } from "../AccountSelectorModal/RemoveAccountModal";
import { ConfirmationModal } from "../ConfirmationModal";

export const LogoutModal = () => {
  const handleLogout = async () => {
    if (persistor) {
      await logout(store, persistor);
    }
  };

  return (
    <ConfirmationModal
      buttonLabel="Sign out"
      description={getRemoveDefaultAccountDescription("seedphrase")}
      onSubmit={handleLogout}
      title="Sign out"
    />
  );
};
